export { default } from './BoxFooter';
